module.exports = __webpack_public_path__ + "img/92190.b5534df4.svg";